<div
  class="vh-100 vw-100 d-flex flex-column page"
  [ngClass]="
    themeSwitcher.getCurrentTheme().endsWith(themeSwitcher.suffixLight)
      ? 'theme-classic-light '
      : 'theme-classic-dark'
  "
  >
  <div class="content-wrapper">
    <app-navbar [showLogo]="false"></app-navbar>
  </div>

  <div
    class="background-image flex-grow-1 d-flex flex-column justify-content-center align-items-center"
    >
    <div class="login-overlay">
      <div class="w-100">
        <ix-typography id="loginSystemName" format="display-xs" bold="true"
          >{{ 'dpp.login.system_name' | translate }}
        </ix-typography>
        <ix-typography
          bold="true"
          class="product-name-text"
          format="display-xl"
          id="loginProductName"
          >{{ 'dpp.login.product_name' | translate }}
        </ix-typography>
      </div>
      <ix-typography
        class="w-100"
        color="soft"
        format="body-lg"
        id="loginDescription"
        >{{ 'dpp.login.description' | translate }}
      </ix-typography>
      <ix-button
        (click)="onLoginClick()"
        class="w-100 login-button"
        onkeypress=""
        variant="primary"
        >{{ 'dpp.login.login' | translate }}
        </ix-button
        >
        <ix-typography format="label" bold="true" class="w-100 px-2 py-3"
          >{{ 'login.no_account' | translate }}
          <a (click)="onRegisterLinkClick()" class="ms-3 register-link">{{
            'login.register' | translate
          }}</a>
        </ix-typography>
      </div>
    </div>

    <ng-template #loginErrorModal let-modal>
      <ix-modal
      [ngClass]="
        themeSwitcher.getCurrentTheme().endsWith(themeSwitcher.suffixLight)
          ? 'theme-classic-light '
          : 'theme-classic-dark'
      "
        >
        <ix-modal-header>
          @switch (errorType) {
            @case ('noUser') {
              {{ 'login.errors.error_head_no_user' | translate }}
            }
            @case ('forbidden') {
              {{ 'login.errors.error_head_forbidden' | translate }}
            }
            @case ('unknown') {
              {{ 'login.errors.error_head_unknown' | translate }}
            }
            @case ('inactivityLogout') {
              {{ 'login.errors.error_head_inactivity_logout' | translate }}
            }
          }
          </ix-modal-header
          >
          <ix-modal-content>
            <ix-typography format="body">
              @switch (errorType) {
                @case ('noUser') {
                  {{ 'login.errors.no_user' | translate }}
                }
                @case ('forbidden') {
                  {{ 'login.errors.forbidden' | translate }}
                }
                @case ('unknown') {
                  {{ 'login.errors.unknown' | translate }}
                }
                @case ('inactivityLogout') {
                  {{ 'login.errors.inactivity_logout' | translate }}
                }
              }
            </ix-typography>
            <br/>
            <ix-typography format="body"
              >{{ 'dpp.login.error_modal.support' | translate }}
              <a
                class="link"
                target="_blank"
                rel="noopener"
                href="{{ 'dpp.login.error_modal.support_link' | translate }}"
                >{{ 'dpp.login.error_modal.support_link_text' | translate }}</a
                >.
              </ix-typography>
            </ix-modal-content>
            <ix-modal-footer>
              <ix-button
                (click)="modal.close('okay')"
                class="close-modal"
                onkeypress=""
                variant="primary"
                >
                OK
              </ix-button>
            </ix-modal-footer>
          </ix-modal>
        </ng-template>
        <app-dynamic-footer
          version="1.0.0"
    [links]="[
      { text: 'dpp.links.siemens_battery_passport_text', href: 'dpp.links.siemens_battery_passport_link' },
      { text: 'dpp.links.idta_text', href: 'dpp.links.idta_link' }
    ]"
        ></app-dynamic-footer>
      </div>
